import { render } from "./SmModalEditComponent.vue?vue&type=template&id=e4170fa8"
import script from "./SmModalEditComponent.vue?vue&type=script&lang=js"
export * from "./SmModalEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/SmModalEditComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e4170fa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e4170fa8', __exports__)) {
    api.reload('e4170fa8', __exports__)
  }
  
  module.hot.accept("./SmModalEditComponent.vue?vue&type=template&id=e4170fa8", () => {
    api.rerender('e4170fa8', render)
  })

}


export default __exports__